import { combineReducers } from 'redux'

// ACTIONS
export const CREATE = 'offerzen/desiredRoles/CREATE'
export const CREATE_SUCCESS = 'offerzen/desiredRoles/CREATE_SUCCESS'

export const FETCH = 'offerzen/desiredRoles/FETCH'
export const FETCH_SUCCESS = 'offerzen/desiredRoles/FETCH_SUCCESS'

export const UPDATE = 'offerzen/desiredRoles/UPDATE'
export const UPDATE_SUCCESS = 'offerzen/desiredRoles/UPDATE_SUCCESS'

export const DELETE = 'offerzen/desiredRoles/DELETE'
export const DELETE_SUCCESS = 'offerzen/desiredRoles/DELETE_SUCCESS'

export const SET_ROLE_TO_DELETE = 'offerzen/desiredRoles/SET_ROLE_TO_DELETE'

// ACTION CREATORS
export const createRole = (id, data) => ({
  type: CREATE,
  payload: { id, data },
})

export const createRoleSuccess = data => ({
  type: CREATE_SUCCESS,
  payload: {
    ...data,
    editing: false,
  },
})

export const updateRole = (candidate_id, id, data) => ({
  type: UPDATE,
  payload: { candidate_id, id, data },
})

export const updateRoleSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: {
    ...data,
    editing: false,
  },
})

export const fetchRoles = id => ({
  type: FETCH,
  payload: { id },
})

export const fetchRolesSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: [...data],
})

export const deleteRole = (candidate_id, id) => ({
  type: DELETE,
  payload: { candidate_id, id },
})

export const deleteRoleSuccess = data => ({
  type: DELETE_SUCCESS,
  payload: data,
})

export const setRoleToDelete = roleToDelete => ({
  type: SET_ROLE_TO_DELETE,
  payload: { roleToDelete },
})

// REDUCERS
const defaultRoles = []

const entities = (state = defaultRoles, { type, payload }) => {
  switch (type) {
    case FETCH_SUCCESS:
      return [...payload]

    case CREATE_SUCCESS:
      return [...state, payload]

    default:
      return [...state]
  }
}

const roleToDelete = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_ROLE_TO_DELETE:
      return {
        ...state,
        ...payload.roleToDelete,
      }

    default:
      return state
  }
}

const creatingRole = (state = false, { type, payload }) => {
  switch (type) {
    case CREATE:
      return true

    case CREATE_SUCCESS:
      return false

    default:
      return state
  }
}

const updatingRole = (state = false, { type, payload }) => {
  switch (type) {
    case UPDATE:
      return true

    case UPDATE_SUCCESS:
      return false

    default:
      return state
  }
}

const deletingRole = (state = false, { type, payload }) => {
  switch (type) {
    case DELETE:
      return true

    case DELETE_SUCCESS:
      return false

    default:
      return state
  }
}

const desiredRolesReducer = combineReducers({
  entities,
  roleToDelete,
  creatingRole,
  updatingRole,
  deletingRole,
})

export default desiredRolesReducer

export const getRoles = state => state.views.profile.desiredRoles.entities || defaultRoles
